import { BarDatum, ComputedBarDatum } from "@nivo/bar"
import React from "react"
import { useBarOffsets } from "~Shared/hooks/useBarOffsets"
import { CustomBarComponent } from "./customBarComponent"

interface CustomBarsLayerProps {
    bars: ReadonlyArray<ComputedBarDatum<BarDatum>>
    borderRadius: number
    borderWidth: number
    isInteractive: boolean
    onClick?: (bar: ComputedBarDatum<BarDatum>["data"] & { color: string }, event: React.MouseEvent) => void
    onMouseEnter?: (bar: ComputedBarDatum<BarDatum>["data"], event: React.MouseEvent) => void
    onMouseLeave?: (bar: ComputedBarDatum<BarDatum>["data"], event: React.MouseEvent) => void
    tooltip: React.FC<{ id: string | number; value: number; color: string }>
    getTooltipLabel: (datum: ComputedBarDatum<BarDatum>["data"]) => string | number
    stackKeys: Array<string>
}

/**
 * Custom bars layer that pre-calculates all offsets using useMemo,
 * then passes the offsets map to each bar component for lookup.
 */
export const CustomBarsLayer = ({
    bars,
    borderRadius,
    borderWidth,
    isInteractive,
    onClick,
    onMouseEnter,
    onMouseLeave,
    tooltip,
    getTooltipLabel,
    stackKeys,
}: CustomBarsLayerProps) => {
    // Pre-calculate all offsets based on bar data
    const offsets = useBarOffsets(
        bars.map((bar) => ({
            id: String(bar.data.id),
            indexValue: String(bar.data.indexValue),
            height: bar.height,
            value: bar.data.value,
        })),
        stackKeys,
    )

    return (
        <g>
            {bars.map((bar) => (
                <CustomBarComponent
                    key={bar.key}
                    bar={bar}
                    borderRadius={borderRadius}
                    borderWidth={borderWidth}
                    label={String(getTooltipLabel(bar.data))}
                    shouldRenderLabel={false}
                    isInteractive={isInteractive}
                    onClick={onClick}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    tooltip={tooltip}
                    offsets={offsets}
                />
            ))}
        </g>
    )
}
